<template>
	<div class="model1">
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<el-select
					:clearable="true"
					@change="changeAreaFn"
					v-model="regionIds"
					placeholder="请选择银行"
					style="border: 1px solid #F3F3F3;"
				>
					<el-option label="工商银行" value="工商银行"></el-option>
					<el-option label="建设银行" value="建设银行"></el-option>
					<el-option label="农业银行" value="农业银行"></el-option>
					<el-option label="中国银行" value="中国银行"></el-option>
					<el-option label="交通银行" value="交通银行"></el-option>
					<el-option label="光大银行" value="光大银行"></el-option>
					<el-option label="平安银行" value="平安银行"></el-option>
					<el-option label="华夏银行" value="华夏银行"></el-option>
					<el-option label="浦发银行" value="浦发银行"></el-option>
					<el-option label="兴业银行" value="兴业银行"></el-option>
					<el-option label="招商银行" value="招商银行"></el-option>
					<el-option label="中信银行" value="中信银行"></el-option>
					<el-option label="北京银行" value="北京银行"></el-option>
					<el-option label="南京银行" value="南京银行"></el-option>
					<el-option label="宁波银行" value="宁波银行"></el-option>
					<el-option label="邮储银行" value="邮储银行"></el-option>
					<el-option label="民生银行" value="民生银行"></el-option>
					<el-option
						label="国家开发银行"
						value="国家开发银行"
					></el-option>
					<el-option
						label="中国进出口银行"
						value="中国进出口银行"
					></el-option>
					<el-option
						label="中国农业发展银行"
						value="中国农业发展银行"
					></el-option>
					<el-option label="浙商银行" value="浙商银行"></el-option>
					<el-option label="渤海银行" value="渤海银行"></el-option>
					<el-option label="广发银行" value="广发银行"></el-option>
				</el-select>
				<el-date-picker
					@change="changeDateFn"
					style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
					size="large"
					v-model="dateRaneg"
					unlink-panels
					type="monthrange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
				<div @click="downloadTable" class="m1_download_data">
					导出数据
				</div>
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					border
				>
					<el-table-column
						v-for="(item, index) in dataList[0]"
						:prop="index"
						:label="item"
						:show-overflow-tooltip="true"
						:sortable="false"
						align="center"
						:key="index"
						:min-width="
							tableColumnWidth[index] < 24
								? tableColumnWidth[index] * 16
								: tableColumnWidth[index] * 8
						"
					>
					</el-table-column>
				</el-table>
				<el-empty
					v-if="dataList.length <= 0"
					description="暂无数据!"
				></el-empty>
			</ul>
			<div style="font-size: 14px;float: right;">
				数据来源：银行定期报告
			</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';
import axios from 'axios';

export default {
	// 能源展示数据--全国各省
	props: ['currentChoose'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			regionIds: '', //当前传值选中的地区
			options: [
				{
					value: 1,
					label: '东南',
					children: [
						{
							value: 2,
							label: '上海',
							children: [
								{ value: 3, label: '普陀' },
								{ value: 4, label: '黄埔' },
								{ value: 5, label: '徐汇' },
							],
						},
					],
				},
				{
					value: 17,
					label: '西北',
					children: [
						{
							value: 18,
							label: '陕西',
							children: [
								{ value: 19, label: '西安' },
								{ value: 20, label: '延安' },
							],
						},
					],
				},
			],
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
			titleAnd1: '',
			titleAnd2: '',
			titleAnd3: '',
			titleAnd4: '',
		};
	},
	watch: {
		currentChoose(val) {
			this.regionIds = '';
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.fetchAreaDataList(val);
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
			//console.log(val, 'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);
		this.fetchAreaDataList(this.currentChoose);
	},
	methods: {
		//点击下载按钮
		downloadTable() {
			let _this = this;
			let tmp_regionIds = [
				...new Set(this.regionIds.toString().split(',')),
			].toString();
			let params = {
				indexId: _this.currentChoose,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				regionIds: tmp_regionIds,
			};

			axios({
				method: 'post',
				url: window.normalUrl + '/down/downTrustYearData', // 请求地址
				data: params,
				responseType: 'arraybuffer',
				observe: 'response',
			}).then((res) => {
				const fileName = decodeURIComponent(
					res.headers['content-disposition']
						.split(';')[1]
						.split('=')[1]
				);
				let blob = new Blob([res.data], {
					type:
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				// //console.log(decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1]),'blob');
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
					// navigator.msSaveBlob(blob);
				}
			});
		},
		//选中某个地区函数
		changeAreaFn(val) {
			this.regionIds = val;
			this.fetchDataList(this.currentChoose);
			//console.log(val, 'val-fn');
		},
		//table的单元格样式
		cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0 && row.rowIndex > 0) {
				return 'background:#F5F7F5;';
			}
			if (row.rowIndex == 0) {
				return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;';
			}
			// if (row.rowIndex % 2 == 0) {
			// 	return 'background:#fff;';
			// } else {
			// 	return 'background:#F5F7F5;';
			// }
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			let params = {
				indexId: _id,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				bankName: this.regionIds,
			};
			this.loading = true;
			api.getTrustYearData(params).then((res) => {
				console.log(res, 'list');
				_this.dataList = res.data.rows;
				_this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//获取地区选项数据
		fetchAreaDataList(_id) {
			var _id = 1;
			let _this = this;
			api.getRegionList(_id).then((res) => {
				//console.log(res, 'area');
				_this.options = res.data;
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.m1_echarts_alert {
	width: 313px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 200000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
.m1_top_box {
	width: 100%;
	overflow: hidden;
}
.m1_top_box h5 {
	width: 420px;
	height: 50px;
	line-height: 50px;
	float: left;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
}
.m1_top_box h5:first-child {
	margin-right: 40px;
}
.m1_top_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
.m1_echarts_box {
	width: 100%;
	overflow: hidden;
	margin-top: 85px;
	display: flex;
	justify-content: space-evenly;
}
.m1_echarts1 {
	width: 368px;
	height: 280px;
	float: left;
}
.m1_echarts2 {
	width: 368px;
	height: 280px;
	float: right;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 40px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 40px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/lvcolumn/mode5.vue